// removed by extract-text-webpack-plugin
module.exports = {"if":"if__1lKDz","swipe":"swipe__6HrWS","recommended":"recommended__3_KTX","arrow-right":"arrow-right__1zGBk"};


//////////////////
// WEBPACK FOOTER
// ./components/Icon/index.scss
// module id = 7ROj
// module chunks = 0